/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_NOTIFICATIONS,
  ADD_NOTIFICATIONS,
  CLEAR_NOTIFICATIONS
} from 'src/actions/notificationsActions';

const initialState = {
  notifications: [],
  count: 0
};

const notificationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_NOTIFICATIONS: {
      const { notifications } = action.payload;

      return produce(state, draft => {
        draft.notifications = notifications;
      });
    }

    case ADD_NOTIFICATIONS: {
      return produce(state, draft => {
        draft.count = draft.count + action.payload;
      });
    }
    case CLEAR_NOTIFICATIONS: {
      return produce(state, draft => {
        draft.count = 0;
      });
    }
    default: {
      return state;
    }
  }
};

export default notificationsReducer;
